import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Drafts", -1)

import { ref, onMounted } from 'vue';

import ButtonComponent from "@/components/buttons/ButtonComponent.vue";

import DraftService from "@/classes/Drafts/DraftService";
import { useRouter } from "vue-router";
import { number } from 'zod';


export default /*#__PURE__*/_defineComponent({
  __name: 'DraftLink',
  props: {
    count: {
        type: number,
        default: 0
    }
},
  setup(__props) {



const draftCount = ref<any>(0);
const router = useRouter();
// const init = async (): Promise<void> => {
    // console.log('init draflink')
    // await DraftService.hasDrafts().then((res: any) => ( draftCount.value = res ));
// }

// onMounted(() => {
    // init()
// })
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/draft/index')))
  }, [
    _createVNode(ButtonComponent, {
      size: "small",
      customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })
  ]))
}
}

})